module.exports = __webpack_public_path__ + "media/images/pic/blank/226x183-fd98ba4f09b2232344638db9a337da46.jpg";